import * as Yup from "yup";

export interface TextareaFormValues {
	otherReport: string;
	otherReport2: string;
	report: string;
	select_id: string;
}

export const reportValidationSchema = Yup.object({
	report: Yup.string().when("select_id", {
		is: (val: string) => val !== "8284cccf-1378-46f1-b987-0a36937fda99",
		then: (schema) => schema.required("Report is required"),
		otherwise: (schema) => schema.notRequired(),
	}),
	otherReport: Yup.string().when("select_id", {
		is: (val: string) => val === "8284cccf-1378-46f1-b987-0a36937fda99",
		then: (schema) => schema.required("Additional info is required"),
		otherwise: (schema) => schema.notRequired(),
	}),
});
